export default "__VITE_ASSET__eeV7eqt8__"